import { RelodeApiError } from "../../";
import * as React from "react";

import { useNotifications } from "..";
import { SuccessAction, SuccessActionType } from "./actionTypes";

export type MiddlewareAction = (action: React.ReducerAction<any>) => void;

export const useSnackMiddleware = () => {
    const { actions: notifications } = useNotifications();
    return (action: any) => {
        if (action.meta instanceof SuccessAction) {
            const _action = action.meta as SuccessAction;
            notifications.showSnack("success", _action.message, {
                autoCloseDuration: 5000,
            });
        }
        if (!!(action as SuccessActionType).successMessage) {
            notifications.showSnack(
                "success",
                (action as SuccessActionType).successMessage,
                { autoCloseDuration: 5000 }
            );
        }
    };
};

export const logAction = (action: any) => {
    if (action.meta instanceof RelodeApiError) {
        console.error(`ERROR ${action.type}`, action.meta);
    } else {
        console.log(action.type, action);
    }
};
